package org.example.zone360.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.core.rememberPageContext
import kotlinx.browser.localStorage
import org.example.zone360.pages.authentication.LoginPage
import org.example.zone360.pages.dashboard.DashboardPage
import org.example.zone360.pages.players_Details.PlayersDetails
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Strings

@Page
@Composable
fun HomePage() {
    if (rememberPageContext().isExporting) return

    val data = localStorage.getItem("userData")
    if (data != null)
    {if (AppGlobal.userData.role == Strings.PLAYER) PlayersDetails() else DashboardPage() }
    else LoginPage()
}


